import api from './api'

const URL = '/api/employee'
let service = {}

service.getMechanics = function () {
  return api.get(`${URL}/v2/mechanics`).then(res => res.data).catch(err => {
    return err.response
  })
}

export default service
